import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';

import { WebContentTypeService } from '../../web-content/shared/web-content-type.service';
import { WebContentType } from '../../shared/model/webcontenttype.model';
import { FormElementFile } from '../shared/model/form-element-file.model';

@Component({
  selector: 'wl-form-builder-upload-file-edit-element',
  templateUrl: 'form-builder-upload-file-edit-element.component.html',
    standalone: false
})
export class FormBuilderFileUploadEditElementComponent implements OnInit {
  private _translationService: TranslationService;
  private _webContentTypeService: WebContentTypeService;

  public webContentTypes: Array<WebContentType>;
  public fileUploadSettings: FormElementFile;
  public selectedWebContentTypeId: number;

  public constructor(translationService: TranslationService, webContentTypeService: WebContentTypeService) {
    this._translationService = translationService;
    this._webContentTypeService = webContentTypeService;
  }

  ngOnInit() {
    this.fileUploadSettings = new FormElementFile();
    this.webContentTypes = new Array<WebContentType>();
    this.fileUploadSettings.LabelText = this._translationService.getInstantTitlecase('forms.form-builder.upload-file.label-text');

    this._webContentTypeService.getWebContentTypes().then((data: any) => {
      this.webContentTypes = data.Result;
    });
  }
}
